import { cn } from "@/lib/utils";

/** The assistant's little face. Used instead of generic "AI" icons across the site. */
export default function AssistantFace({ className, ...rest }) {
  return (
    <img
      src="/brand/assistant-face.webp"
      alt=""
      aria-hidden="true"
      draggable={false}
      className={cn("inline-block shrink-0 select-none object-contain", className)}
      {...rest}
    />
  );
}
